import React, { useEffect, useState } from 'react';
import { Transition } from 'react-spring/renderprops-universal.cjs';
import classNames from 'classnames';
import { Testable, Tourable } from './types';
// CSS-based loader components
const Loader = () => (
  <div className="animate-spin rounded-full h-12 w-12 border-4 border-gray-300 border-t-blue-600"></div>
);

const WhiteLoader = () => (
  <div className="animate-spin rounded-full h-12 w-12 border-4 border-gray-600 border-t-white"></div>
);

export const LoadingGif = Loader;
export const WhiteLoadingGif = WhiteLoader;

export interface LoadingContainerProps {
  loading: boolean;
  message?: React.ReactNode;
  className?: string;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  childrenClassName?: string;
}

export function LoadingContainer(
  props: Tourable<Testable<LoadingContainerProps>>,
) {
  const [message, setMessage] = useState(props.message);

  useEffect(() => {
    if (props.message) {
      setMessage(props.message);
    }
  }, [props.message]);

  return (
    <Transition
      items={props.loading}
      from={{
        position: 'absolute',
        opacity: 0,
        left: 0,
        right: 0,
        height: '100%',
      }}
      enter={{ opacity: 1, position: 'relative' }}
      leave={{
        opacity: 0,
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
      }}
    >
      {(loading) =>
        loading
          ? (transitionStyle) => (
              <div
                data-test-id={`${props['data-test-id']}_loading`}
                style={transitionStyle as any}
                className={props.className}
                guided-tour-id={props['guided-tour-id']}
              >
                <div className="flex flex-col items-center justify-center w-full h-full">
                  {!!message && <p className="mb-10">{message}</p>}
                  <Loader />
                  <div className="mt-10">{props.footer}</div>
                </div>
              </div>
            )
          : (transitionStyle) => (
              <div
                data-test-id={props['data-test-id']}
                style={transitionStyle as any}
                className={classNames('h-full', props.childrenClassName)}
              >
                {props.children}
              </div>
            )
      }
    </Transition>
  );
}
